module.exports = {
    resumePageScrollTop: 0,
    // 个人简历内容
    myResumeInfo: null,
    // 显示的简历内容
    resumeInfo: null,
    // 强制刷新简历标志
    refreshResumeFlag: true,
    // 解析出的简历数据(附件或者是第三方)
    analysisResume: null,
    // 新鹰计划标识
    resumeEagleFlag: false
}



// WEBPACK FOOTER //
// ./src/store/resume/state.js